import { dracoOptions } from './draco';
import { grusOptions } from './grus'

const swan600Model = [
    {
        label: 'Swan 600',
        value: 'Swan600',
    },
    {
        label: 'Swan 610E',
        value: 'Swan610E',

    },
    {
        label: 'Swan 620E',
        value: 'Swan620E',

    },
    {
        label: 'Swan 610S',
        value: 'Swan610S',

    },
    {
        label: 'Swan 620S',
        value: 'Swan620S',

    },
    {
        label: 'Swan 650M',
        value: 'Swan650M',

    },
    {
        label: 'Swan 660M',
        value: 'Swan660M',

    },
    {
        label: 'Swan 660S',
        value: 'Swan660S',

    },
    {
        label: 'Swan 670M',
        value: 'Swan670M',

    },
    {
        label: 'Swan 690M',
        value: 'Swan690M',

    },
];

const swan700Model = [
    {
        label: 'Swan 700',
        value: 'TE700',
    },
    {
        label: 'Swan 710E',
        value: 'TE710E',

    },
    {
        label: 'Swan 710S',
        value: 'TE710S',
    },
    {
        label: 'Swan 720E',
        value: 'TE720E',
    },
    {
        label: 'Swan 720S',
        value: 'TE720S',
    },
    {
        label: 'Swan 750M',
        value: 'TE750M',
    },
    {
        label: 'Swan 760M',
        value: 'TE760M',
    },
];

const swan700PModel = [
    {
        label: 'Swan 700P',
        value: 'TE700P',
    },
    {
        label: 'Swan 730E',
        value: 'TE730E',
    },
    {
        label: 'Swan 730S',
        value: 'TE730S',
    },
    {
        label: 'Swan 750S',
        value: 'TE750S',
    },
    {
        label: 'Swan 760E',
        value: 'TE760E',
    },
    {
        label: 'Swan 760S',
        value: 'TE760S',
    },
    {
        label: 'Swan 770M',
        value: 'TE770M',
    },
    {
        label: 'Swan 780M',
        value: 'TE780M',
    },
    {
        label: 'Swan 790M',
        value: 'TE790M',
    },
];

const swan600PModel = [
    {
        label: 'Swan 600P',
        value: 'Swan600P',
    },
    {
        label: 'Swan 630E',
        value: 'Swan630E',
    },
    {
        label: 'Swan 660E',
        value: 'Swan660E',
    },
    {
        label: 'Swan 630S',
        value: 'Swan630S',
    },
    {
        label: 'Swan 650S',
        value: 'Swan650S',
    },
    {
        label: 'Swan 660S',
        value: 'Swan660S',
    },
    {
        label: 'Swan 670M',
        value: 'Swan670M',
    },
    {
        label: 'Swan 680M',
        value: 'Swan680M',
    },
    {
        label: 'Swan 690M',
        value: 'Swan690M',
    },
];

const columbaModel = [
    {
        label: '天鸽 300',
        value: 'columba300',
    },
    {
        label: '天鸽 300S',
        value: 'columba300S',
    },
    {
        label: '天鸽 310S',
        value: 'columba310S',
    },
    {
        label: '天鸽 310E',
        value: 'columba310E',
    },
    {
        label: '天鸽 320S',
        value: 'columba320S',
    },
    {
        label: '天鸽 320E',
        value: 'columba320E',
    },
    {
        label: '天鸽 330S',
        value: 'columba330S',
    },
    {
        label: '天鸽 330E',
        value: 'columba330E',
    },
    {
        label: '天鸽 350S',
        value: 'columba350S',
    },
    {
        label: '天鸽 350E',
        value: 'columba350E',
    },
    {
        label: '天鸽 360M',
        value: 'columba360M',
    },
    {
        label: '天鸽 370M',
        value: 'columba370M',
    },
    {
        label: '天鸽 380M',
        value: 'columba380M',
    },
    {
        label: '天鸽 390M',
        value: 'columba390M',
    },
];

const SXCModel = [
    {
        label: "310",
        value: "筛查箱 310"
    },
    {
        label: "310S",
        value: "筛查箱 310S"
    },
];


const LanWModel = [
    {
        label: "110",
        value: "蓝鲸 110"
    },
    {
        label: "120",
        value: "蓝鲸 120"
    },
    {
        label: "130",
        value: "蓝鲸 130"
    },
];

const StartonModel = [
    {
        label: "220",
        value: "星豚 220"
    },
    {
        label: "230",
        value: "星豚 230"
    },
    {
        label: "260",
        value: "星豚 260"
    },
    {
        label: "270",
        value: "星豚 270"
    },
];

const lynModel = [
    {
        label: "100",
        value: "天猫LYN-100"
    },
    {
        label: "130",
        value: "天猫LYN-130"
    },
];

const TY600LIST = [
    {
        label: "天鹰610S",
        value: 'TY610S',
        letter: "A",
    },
    {
        label: "天鹰620S",
        value: 'TY620S',
        letter: "A",
    },
    {
        label: "天鹰630S",
        value: 'TY630S',
        letter: "A",
    },
    {
        label: "天鹰650S",
        value: 'TY650S',
        letter: "A",
    },
    {
        label: "天鹰660S",
        value: 'TY660S',
        letter: "A",
    },
    {
        label: "天鹰661S",
        value: 'TY661S',
        letter: "A",
    },
    {
        label: "天鹰650M",
        value: 'TY650M',
        letter: "A",
    },
    {
        label: "天鹰660M",
        value: 'TY660M',
        letter: "A",
    },
    {
        label: "天鹰670M",
        value: 'TY670M',
        letter: "A",
    },
    {
        label: "天鹰680M",
        value: 'TY680M',
        letter: "A",
    },
    {
        label: "天鹰690M",
        value: 'TY690M',
        letter: "A",
    },
];

const TY700LIST = [
    {
        label: "天鹰710S",
        value: 'TY710S',
        letter: "B",
    },
    {
        label: "天鹰720S",
        value: 'TY720S',
        letter: "B",
    },
    {
        label: "天鹰730S",
        value: 'TY730S',
        letter: "B",
    },
    {
        label: "天鹰750S",
        value: 'TY750S',
        letter: "B",
    },
    {
        label: "天鹰760S",
        value: 'TY760S',
        letter: "B",
    },
    {
        label: "天鹰761S",
        value: 'TY761S',
        letter: "B",
    },
    {
        label: "天鹰750M",
        value: 'TY750M',
        letter: "B",
    },
    {
        label: "天鹰760M",
        value: 'TY760M',
        letter: "B",
    },
    {
        label: "天鹰770M",
        value: 'TY770M',
        letter: "B",
    },
    {
        label: "天鹰780M",
        value: 'TY780M',
        letter: "B",
    },
    {
        label: "天鹰790M",
        value: 'TY790M',
        letter: "B",
    },
];

const TC600LIST = [
    {
        label: "天鹿610S",
        value: 'TC610S',
        letter: "A",
    },
    {
        label: "天鹿620S",
        value: 'TC620S',
        letter: "A",
    },
    {
        label: "天鹿630S",
        value: 'TC630S',
        letter: "A",
    },
    {
        label: "天鹿650S",
        value: 'TC650S',
        letter: "A",
    },
    {
        label: "天鹿660S",
        value: 'TC660S',
        letter: "A",
    },
    {
        label: "天鹿650M",
        value: 'TC650M',
        letter: "A",
    },
    {
        label: "天鹿660M",
        value: 'TC660M',
        letter: "A",
    },
    {
        label: "天鹿670M",
        value: 'TC670M',
        letter: "A",
    },
    {
        label: "天鹿680M",
        value: 'TC680M',
        letter: "A",
    },
    {
        label: "天鹿690M",
        value: 'TC690M',
        letter: "A",
    },
];

const TC700LIST = [
    {
        label: "天鹿710S",
        value: 'TC710S',
        letter: "B",
    },
    {
        label: "天鹿720S",
        value: 'TC720S',
        letter: "B",
    },
    {
        label: "天鹿730S",
        value: 'TC730S',
        letter: "B",
    },
    {
        label: "天鹿750S",
        value: 'TC750S',
        letter: "B",
    },
    {
        label: "天鹿760S",
        value: 'TC760S',
        letter: "B",
    },
    {
        label: "天鹿750M",
        value: 'TC750M',
        letter: "B",
    },
    {
        label: "天鹿760M",
        value: 'TC760M',
        letter: "B",
    },
    {
        label: "天鹿770M",
        value: 'TC770M',
        letter: "B",
    },
    {
        label: "天鹿780M",
        value: 'TC780M',
        letter: "B",
    },
    {
        label: "天鹿790M",
        value: 'TC790M',
        letter: "B",
    },
];

export const serialModelOptions = {
    'Swan 600': swan600Model,
    'Swan 600P': swan600PModel,
    'Swan 700': swan700Model,
    'Swan 700P': swan700PModel,
    'Draco 800': dracoOptions.draco800,
    'Draco 900': dracoOptions.draco900,
    'Grus 700': grusOptions.grus700,
    'columba': columbaModel,
    'SCX': SXCModel,
    'LanW': LanWModel,
    'Starton': StartonModel,
    'lynModel': lynModel,
    'TY600': TY600LIST,
    'TY700': TY700LIST,
    'TC600': TC600LIST,
    'TC700': TC700LIST,
};

const modelOptions = [
    {
        label: "天鹅600",
        value: "Swan 600",
        children: swan600Model,
    },
    {
        label: "天鹅600P",
        value: "Swan 600P",
        children: swan600PModel,
    },
    {
        label: "天鹅700",
        value: "Swan 700",
        children: swan700Model,
    },
    {
        label: "天鹅700P",
        value: "Swan 700P",
        children: swan700PModel,
    },
    {
        label: "天龙800",
        value: "Draco 800",
        children: dracoOptions.draco800,
    },
    {
        label: "天龙900",
        value: "Draco 900",
        children: dracoOptions.draco900,
    },
    {
        label: "天鹤",
        value: "Grus 700",
        children: grusOptions.grus700,
    },
    {
        label: "天鹿600",
        value: "TC600",
        children: TC600LIST,
    },
    {
        label: "天鹿700",
        value: "TC700",
        children: TC700LIST,
    },
    {
        label: "天鹰600",
        value: "TY600",
        children: TY600LIST,
    },
    {
        label: "天鹰700",
        value: "TY700",
        children: TY700LIST,
    },
    {
        label: "蓝鲸",
        value: "LanW",
        children: LanWModel,
    },
    {
        label: "星豚",
        value: "Starton",
        children: StartonModel,
    },
    {
        label: "春晖台灯",
        value: "tableLamp",
    }
    ,
    {
        label: "EYESPA",
        value: "EYESPA",
    }
];

const columba = [
    {
        label: "天鸽",
        value: "columba",
        children: columbaModel
    }
];

const screeningBox = [
    {
        label: "筛查箱",
        value: "SCX",
        children: SXCModel,
    }
];

const LYNModel = [
    {
        label: "天猫",
        value: "天猫-Lyn",
        children: lynModel,
    }
]

const LYARModel = [
    {
        label: "天琴",
        value: "天琴-Lyar",
        children: [
            {
                label: "天琴-Lyar",
                value: "天琴-Lyar"
            },
        ],
    }
]

const optiture = [
    {
        label: "天狼",
        value: "optiture",
        children: [{
            label: "天狼6500S",
            value: "天狼6500S"
        },
        {
            label: "天狼6900M",
            value: "天狼6900M"
        },
        {
            label: "天狼K-6500S",
            value: "天狼K-6500S"
        }
        ],
    }
]

const columba2 = [
    {
        label: "视筛箱Ⅱ代",
        value: "视筛箱Ⅱ代",
    }
]

export const machineOptions = [...modelOptions, ...columba, ...screeningBox, ...LYARModel, ...optiture, ...columba2];

export const swanMachineOptions = [
    {
        label: "天鹅600",
        value: "Swan 600",
        children: swan600Model,
    },
    {
        label: "天鹅600P",
        value: "Swan 600P",
        children: swan600PModel,
    },
    {
        label: "天鹅700",
        value: "Swan 700",
        children: swan700Model,
    },
    {
        label: "天鹅700P",
        value: "Swan 700P",
        children: swan700PModel,
    },
]

export default {
    modelOptions,
    machineOptions
}
